<template>
  <DemoDashboardLayout />
</template>

<script>
import DemoDashboardLayout from '@/components/DemoDashboardLayout.vue'

export default {
  name: 'DemoDashboardView',
  components: {
    DemoDashboardLayout
  }
}
</script>
